<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start" *ngIf="isPage">
      <app-back-button defaultHref="home"></app-back-button>
    </ion-buttons>
    <ion-buttons slot="end" *ngIf="!isPage">
      <ion-button (click)="close()"><ion-icon name="close-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title *ngIf="!isPage">Select Exercise</ion-title>
    <ion-title *ngIf="isPage"><app-logo [height]="30"></app-logo></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" #content>
  <ion-header collapse="condense" *ngIf="isPage">
    <ion-toolbar>
      <ion-title size="large">Exercises Preview</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-searchbar
    placeholder="Search exercises by name"
    (ionInput)="searchExercises($event)"
  ></ion-searchbar>
  <!-- Filters Section -->
  <ion-list>
    <ion-item>
      <ion-select
        label="Primary Muscle"
        [(ngModel)]="filters.primaryMuscles"
        (ionChange)="applyFilters()"
        placeholder="Select Primary Muscle"
        multiple="true"
      >
        <ion-select-option
          *ngFor="let muscle of getAllPrimaryMuscles()"
          [value]="muscle"
          >{{ muscle }}</ion-select-option
        >
      </ion-select>
    </ion-item>

    <ion-item>
      <ion-select
        label="Secondary Muscle"
        [(ngModel)]="filters.secondaryMuscles"
        (ionChange)="applyFilters()"
        placeholder="Select Secondary Muscle"
        multiple="true"
      >
        <ion-select-option
          *ngFor="let muscle of getAllSecondaryMuscles()"
          [value]="muscle"
          >{{ muscle }}</ion-select-option
        >
      </ion-select>
    </ion-item>

    <ion-item>
      <ion-select
        label="Equipment"
        [(ngModel)]="filters.equipment"
        (ionChange)="applyFilters()"
        placeholder="Select Equipment"
      >
        <ion-select-option value="">None</ion-select-option>
        <ion-select-option
          *ngFor="let equipment of getAllEquipment()"
          [value]="equipment"
          >{{ equipment }}</ion-select-option
        >
      </ion-select>
    </ion-item>

    <ion-item>
      <ion-select
        label="Category"
        [(ngModel)]="filters.category"
        (ionChange)="applyFilters()"
        placeholder="Select Category"
      >
        <ion-select-option value="">None</ion-select-option>
        <ion-select-option
          *ngFor="let category of getAllCategories()"
          [value]="category"
          >{{ category }}</ion-select-option
        >
      </ion-select>
    </ion-item>

    <ion-item>
      <ion-select
        label="Level"
        [(ngModel)]="filters.level"
        (ionChange)="applyFilters()"
        placeholder="Select Level"
      >
        <ion-select-option value="">None</ion-select-option>
        <ion-select-option
          *ngFor="let level of getAllLevels()"
          [value]="level"
          >{{ level }}</ion-select-option
        >
      </ion-select>
    </ion-item>

    <ion-item>
      <ion-select
        label="Force"
        [(ngModel)]="filters.force"
        (ionChange)="applyFilters()"
        placeholder="Select Force"
      >
        <ion-select-option value="">None</ion-select-option>
        <ion-select-option
          *ngFor="let force of getAllForces()"
          [value]="force"
          >{{ force }}</ion-select-option
        >
      </ion-select>
    </ion-item>

    <ion-item>
      <ion-select
        label="Mechanic"
        [(ngModel)]="filters.mechanic"
        (ionChange)="applyFilters()"
        placeholder="Select Mechanic"
      >
        <ion-select-option value="">None</ion-select-option>
        <ion-select-option
          *ngFor="let mechanic of getAllMechanics()"
          [value]="mechanic"
          >{{ mechanic }}</ion-select-option
        >
      </ion-select>
    </ion-item>
  </ion-list>

  <ion-button
    *ngIf="!isPage"
    class="py px"
    expand="block"
    fill="outline"
    (click)="emitSelectedExercises()"
    >Add Selected Exercises
  </ion-button>

  <!-- Exercises List -->
  <ion-list *ngIf="isPage">
    <ion-item
      *ngFor="let exercise of filteredExercises"
      (click)="showDetail(exercise)"
    >
      <ion-thumbnail slot="start">
        <ion-img
          [src]="exercise.images[0] | fetchExerciseImage | async"
        ></ion-img>
      </ion-thumbnail>
      <ion-label>
        <h2>{{ exercise.name }}</h2>
        <p>Primary Muscles: {{ exercise.primaryMuscles.join(", ") }}</p>
        <p *ngIf="exercise.secondaryMuscles.length > 0">
          Secondary Muscles: {{ exercise.secondaryMuscles.join(", ") }}
        </p>
      </ion-label>
    </ion-item>
  </ion-list>
  <!-- Exercises List -->
  <ion-list *ngIf="!isPage">
    <ion-item *ngFor="let exercise of filteredExercises">
      <ion-checkbox
        slot="end"
        (ionChange)="
          updateSelectedExercises(exercise.id, $event.detail.checked)
        "
        [checked]="selectedExercises.has(exercise.id)"
      >
    </ion-checkbox>
      <ion-thumbnail
        slot="start"
        (click)="showDetail(exercise); $event.stopPropagation()"
      >
        <ion-img
          [src]="exercise.images[0] | fetchExerciseImage | async"
        ></ion-img>
      </ion-thumbnail>
      <ion-label>
        <h2>{{ exercise.name }}</h2>
        <p>Primary Muscles: {{ exercise.primaryMuscles.join(", ") }}</p>
        <p *ngIf="exercise.secondaryMuscles.length > 0">
          Secondary Muscles: {{ exercise.secondaryMuscles.join(", ") }}
        </p>
      </ion-label>
    </ion-item>
  </ion-list>

  <ion-infinite-scroll (ionInfinite)="loadMore($event)">
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="Loading more exercises..."
    >
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
